'use client';

import { usePathname } from 'next/navigation';
import { ThemeProvider } from 'next-themes';
import type { ReactNode } from 'react';

/** Keep the marketing landing dark while preserving the app's saved theme. */
export function AppThemeProvider({ children }: { children: ReactNode }): ReactNode {
  const pathname = usePathname();
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      forcedTheme={pathname === '/' ? 'dark' : undefined}
    >
      {children}
    </ThemeProvider>
  );
}
